import find from 'array.prototype.find'
import 'core-js'
import 'raf'

find.shim()

if (!Object.values) Object.values = obj => Object.keys(obj).map(key => obj[key])

if (!String.prototype.includes) {
  /*eslint no-extend-native: 0*/
  String.prototype.includes = function(search, start) {
    if (typeof start !== 'number') {
      start = 0
    }

    if (start + search.length > this.length) {
      return false
    } else {
      return this.indexOf(search, start) !== -1
    }
  }
}



// WEBPACK FOOTER //
// ./src/shims.js